<!--The content below is only a placeholder and can be replaced.-->
<div class="container">

	<app-animated [digit]="22" [duration]="6000"></app-animated>
	<app-animated [digit]="500" [duration]="6000"></app-animated>
	<app-animated [digit]="100" [duration]="6000"></app-animated>

</div>